import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Typography,
} from '@/lib/mui';

interface Props {
  open: boolean;
  title: string;
  description: string;
  onClose: () => void;
  buttons?: React.ReactNode;
  error?: string;
}

export default function CustomDialog({
  open,
  onClose,
  error,
  title,
  description,
  buttons,
}: Props) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>{buttons}</DialogActions>
        {error ? (
          <DialogContent>
            <Typography textAlign="center" variant="body1" color="error">
              {error}
            </Typography>
          </DialogContent>
        ) : null}
      </Dialog>
    </>
  );
}
